export const API_KEY = "AIzaSyDgXNamDcyAjiee8_f5W4snn0gn9HoXNhU"
export const BASE_URL = window.origin;